import React from "react"

import {
    DataGrid,
    GridPaginationModel,
    GridSortModel,
} from "@mui/x-data-grid"

import {
    OrderType,
    SearchFilter,
} from "models"
import {SbPaginatedDatagrid} from "components/commons"

import HistoryTableColumns from "./history-table-columns";
import getHistoryTableColumns from "./history-table-columns";

interface HistoryTableProps
{
    handleCallback: (data: SearchFilter) => void
    data: any | null
}
interface HistoryTableState
{
    pagination: SearchFilter
}
export class HistoryTable extends React.Component<HistoryTableProps, HistoryTableState>
{
    private readonly columns: any

    constructor(props: HistoryTableProps)
    {
        super(props)
        this.columns = getHistoryTableColumns()
        this.state = {
            pagination: {
                pageSize: 25,
                pageId: 0,
                orderBy: "id",
                orderType: OrderType.ASCENDING,
            },
        }
    }

    componentDidMount()
    {
        this.props.handleCallback(this.state.pagination)
    }

    private onPaginationChanged = (pageId: number, pageSize: number): void => {
        this.setState(
            () => ({
                pagination: {
                    ...this.state.pagination,
                    pageSize: pageSize,
                    pageId: pageId,
                },
            }),
            () => this.props.handleCallback(this.state.pagination)
        )
    }

    private onSortChanged = (orderBy: string|null, orderType: OrderType|null): void => {
        this.setState(
            () => ({
                pagination: {
                    pageSize: this.state.pagination.pageSize,
                    pageId: this.state.pagination.pageId,
                    orderBy: orderBy,
                    orderType: orderType,
                },
            }),
            () => this.props.handleCallback(this.state.pagination)
        )
    }

    render()
    {
        const rows: object[] = []

        if(this.props.data !== null) {
            let i

            for(i = 0; i < this.props.data.items.length; i++) {
                let row = {
                    id: this.props.data.items[i].id,
                    title:  this.props.data.items[i].title,
                    status: this.props.data.items[i].status,
                    cost: this.props.data.items[i].cost,
                    paymentStatus: this.props.data.items[i].paymentStatus,
                    progress: this.props.data.items[i].progress,

                }
                rows.push(row)
            }
        }

        return (
            <SbPaginatedDatagrid
                columns={this.columns}
                data={this.props.data}
                pagination={this.state.pagination}
                onPaginationChanged={this.onPaginationChanged}
                onSortChanged={this.onSortChanged}
            />
        )
    }
}
